/* eslint-disable react-hooks/exhaustive-deps */
import { useNavigate } from 'react-router-dom';
import IconTooltipButton from '../../../../../button/IconTooltipButton';
import { useMarkingContext } from '../MarkingContext/MarkingContext';

const ButtonAssesmentSetting = ({ disabled }) => {
  const navigate = useNavigate();

  const { currentPeriodicalReport, loading } = useMarkingContext();

  return (
    <div className='flex justify-end gap-2 pr-2'>
      { currentPeriodicalReport?.status === 'draft' && (
        <IconTooltipButton
          icon={'cog'}
          onClick={() =>
            navigate(`/dashboard/periodical-report/edit/${currentPeriodicalReport?._id}/assessment-area`)
          }
          disabled={loading || disabled}
          style={{
            borderRadius: '0.5rem',
            color: 'var(--primary-foreground)',
            backgroundColor: 'var(--primary)',
            padding: '0.45rem',
            opacity: loading || disabled ? 0.5 : 1
          }}
          className='text-max color-main text-clickeable h-8 w-8'
          title='Assessment areas settings'
        />
      )}
    </div>
  );
};

export default ButtonAssesmentSetting;
